import { Reducer } from "redux";
import { Action, ActionType } from "../../actions";
import { UserPermissionsEditorData } from "../../state/UserPermissions/EditorData";


const updateUserPermissionsEditorData: Reducer<UserPermissionsEditorData> = (state: UserPermissionsEditorData = new UserPermissionsEditorData(), action: Action<ActionType, UserPermissionsEditorData>) => {
  switch (action.type) {
    case ActionType.USER_PERMISSIONS_EDITOR_DATA_RESET:
      return new UserPermissionsEditorData();
    case ActionType.USER_PERMISSIONS_EDITOR_DATA_FETCHED:
      return { ...state, userData: action.data };
    case ActionType.USER_PERMISSIONS_EDITOR_DATA_COPIED:
      return { ...state, userData: { ...action.data} };
    case ActionType.USER_PERMISSIONS_EDITOR_DATA_UPDATED:
      return { ...state, userData: { ...state.userData, permissions: { ...state.userData?.permissions,  ...action.data }} };
    case ActionType.USER_PERMISSIONS_EDITOR_DATA_SAVED:
      return { ...state, readyToSave: false };
    case ActionType.USER_PERMISSIONS_EDITOR_DATA_VALIDATED:
      return { ...state, validation: action.data };
    case ActionType.USER_PERMISSIONS_EDITOR_VALIDATE_DATA_RESET:
      return { ...state, validation: null };
    default:
      return state;
  }
};

export default updateUserPermissionsEditorData;
